import { Button } from "@/components/common";
import { motion } from "framer-motion";

const VisualSection = () => {
  return (
    <section className="relative pb-0 overflow-hidden pt-28">
      {/* 배경 이미지 - 빌딩 */}
      <div className="absolute inset-0 bg-center bg-no-repeat bg-cover pointer-events-none" />

      <div className="relative z-10 max-w-[132rem] mx-auto px-4 sm:px-8 text-center">
        <motion.div
          animate={{ opacity: 1, y: 0 }}
          initial={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          {/* 상단 타이틀 */}
          <p className="text-[1.4rem] sm:text-[2rem] md:text-[2.6rem] text-gray-800 font-bold">
            고객 커뮤니케이션의 모든 것을 한 곳에서
          </p>
          <h1 className="text-[2.4rem] sm:text-[3.2rem] md:text-[4rem] lg:text-[5.2rem] font-extrabold leading-tight">
            통신 서비스의 기준, <span className="text-[#1976D2]">스탠다드네트웍스</span>
          </h1>
          {/* CTA 버튼 */}
          <div className="flex flex-col items-center justify-center gap-4 my-8 sm:flex-row sm:my-14">
            <Button
              variant="custom"
              size="md"
              className="bg-[#1976D2] px-8 h-fit py-4 text-white"
              to="service/submit"
            >
              지금 시작하기
            </Button>
            <Button variant="outline" className="px-8 py-4 h-fit" to="voc/submit">
              문의
            </Button>
          </div>
        </motion.div>

        {/* 업력 */}
        <div className="relative mb-12 sm:mb-20 max-w-container">
          <div className="grid w-full h-full grid-cols-2">
            <div className="w-full h-full">
              <img src="/img/home/1999.png" className="w-2/3 sm:w-2/3" alt="1999" loading="lazy" />
            </div>
            <div className="flex justify-end w-full h-full">
              <img src="/img/home/NOW.png" className="w-2/3 sm:w-2/3" alt="NOW" loading="lazy" />
            </div>
          </div>

          <div className="absolute top-[50%] left-[50%] transform -translate-x-[50%] -translate-y-[50%] w-full px-4">
            <motion.p
              animate={{ opacity: 1, y: 0 }}
              initial={{ opacity: 0, y: 20 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="text-[1.4rem] sm:text-[2rem] md:text-[2.8rem] font-bold text-gray-800 mb-2"
            >
              20년의 시간이 증명하는 메시징 솔루션의 기준 (Standard)
            </motion.p>
            <motion.p
              animate={{ opacity: 1, y: 0 }}
              initial={{ opacity: 0, y: 20 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="text-[1.1rem] sm:text-[1.4rem] md:text-[1.8rem] text-gray-500 leading-relaxed"
            >
              대한민국 메시징 시장을 <span className="font-medium text-[#1976D2]">최초</span>로
              개척한 20년의 노하우로,
              <br />그 어떤 서비스도 흉내 낼 수 없는{" "}
              <span className="font-medium">압도적인 품질</span>과 시스템 안정성을 보장합니다.
            </motion.p>
          </div>
        </div>
      </div>

      {/* 세가지 장점 */}
      <div
        className="relative pt-8 pb-10"
        style={{
          backgroundImage: "url('/img/home/visual_bg.png')",
          backgroundPosition: "center top",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        {/* 배경 회색 처리 */}
        <div className="absolute top-0 left-0 w-full h-full bg-gray-500 bg-opacity-50" />

        {/* 세 가지 선택지 - pill 형태 */}
        <motion.div
          animate={{ opacity: 1, y: 0 }}
          initial={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="relative px-4 sm:px-8 mx-auto max-w-[100rem] z-2"
        >
          <div className="grid grid-cols-1 gap-4 sm:gap-8 md:grid-cols-3 text-[1.4rem] sm:text-[1.8rem] md:text-[2rem] font-medium leading-relaxed">
            <div className="py-8 text-center text-black rounded-lg sm:py-14 bg-white/95">
              <p>
                상담 효율은 높이고
                <br />
                비용은 줄이고 싶다면,
              </p>
            </div>
            <div className="text-center text-black rounded-lg py-14 bg-white/90">
              <p>
                메시지부터 콜센터까지
                <br />한 번에 해결하고 싶다면,
              </p>
            </div>
            <div className="text-center text-black rounded-lg py-14 bg-white/90">
              <p>
                개통 절차 없이
                <br />
                비즈니스 번호가 필요하다면,
              </p>
            </div>
          </div>
        </motion.div>
      </div>
      {/* 화살표와 솔루션 텍스트 */}
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-12 my-8 sm:my-12 text-[1.4rem] sm:text-[2rem] md:text-[2.4rem] font-bold px-4">
        <p
          className="text-center text-transparent bg-clip-text"
          style={{
            backgroundImage: "linear-gradient(90deg, #9ca3af 0%, #1f2937 50%, #1f2937 100%)",
          }}
        >
          당신의 비즈니스에 최적화된
        </p>

        <img src="/img/home/home_arrow_down.png" alt="화살표" className="w-8 sm:w-auto" />

        <p
          className="text-center text-transparent bg-clip-text"
          style={{
            backgroundImage: "linear-gradient(90deg, #1f2937 0%, #1f2937 50%, #9ca3af 100%)",
          }}
        >
          스탠다드네트웍스 자체 솔루션
        </p>
      </div>
    </section>
  );
};

export default VisualSection;
